<template>
    <div class="row font-20 font-medium justify-center mb-3">Thông tin doanh nghiệp</div>

    <DxValidationGroup ref="formValidation">
        <div class="row">
            <div class="xs12">
                <DxTextBox
                    label="Tên doanh nghiệp (*)"
                    v-model="ThongTinDoanhNghiep.TenDoanhNghiep"
                    styling-mode="outlined"
                    validationMessageMode="always"
                    labelMode="floating"
                >
                    <DxValidator>
                        <DxRequiredRule message="Không được bỏ trống!" />
                        <DxStringLengthRule
                            :max="512"
                            message="Không được vượt quá 512 ký tự!"
                        />
                    </DxValidator>
                </DxTextBox>
            </div>
        </div>
        <div class="row mt-5">
            <div class="xs12">
                <DxTextBox
                    label="Mã số thuế (*)"
                    v-model="ThongTinDoanhNghiep.MaSoThue"
                    styling-mode="outlined"
                    validationMessageMode="always"
                    labelMode="floating"
                >
                    <DxValidator>
                        <DxRequiredRule message="Không được bỏ trống!" />
                        <DxStringLengthRule
                            :max="50"
                            message="Không được vượt quá 50 ký tự!"
                        />
                        <DxNumericRule message="Mã số thuế phải là số!" />
                    </DxValidator>
                </DxTextBox>
            </div>
        </div>
        <div class="row mt-5">
            <div class="xs12">
                <DxTextBox
                    label="Số điện thoại (*)"
                    v-model="ThongTinDoanhNghiep.SoDienThoai"
                    styling-mode="outlined"
                    validationMessageMode="always"
                    labelMode="floating"
                >
                    <DxValidator>
                        <DxRequiredRule message="Không được bỏ trống!" />
                        <DxStringLengthRule
                            :max="20"
                            message="Không được vượt quá 20 ký tự!"
                        />
                        <DxNumericRule message="Số điện thoại phải là số!" />
                    </DxValidator>
                </DxTextBox>
            </div>
        </div>
        <div class="row mt-5">
            <div class="xs12">
                <DxTextBox
                    label="Địa chỉ"
                    v-model="ThongTinDoanhNghiep.DiaChi"
                    styling-mode="outlined"
                    validationMessageMode="always"
                    labelMode="floating"
                >
                    <DxValidator>
                        <!-- <DxRequiredRule message="Không được bỏ trống!" /> -->
                        <DxStringLengthRule
                            :max="512"
                            message="Không được vượt quá 512 ký tự!"
                        />
                    </DxValidator>
                </DxTextBox>
            </div>
        </div>
    </DxValidationGroup>

    <div class="row justify-space-between mt-3">
        <DxButton
            type="danger"
            text="Đóng"
            styling-mode="text"
            width="96px"
            @click="Dong"
        />
        <DxButton
            key="mdi-XACNHAN"
            type="default"
            text="Lưu thông tin"
            styling-mode="contained"
            @click="LuuThongTin()"
        />
    </div>
</template>
<script>
import { DxTextBox, DxValidationGroup, DxButton, DxValidator } from "devextreme-vue";
import {
    DxRequiredRule,
    DxStringLengthRule,
    DxNumericRule,
} from "devextreme-vue/validator";

export default {
    components: {
        DxTextBox,
        DxValidationGroup,
        DxButton,
        DxValidator,
        DxRequiredRule,
        DxStringLengthRule,
        DxNumericRule,
    },
    data() {
        return {};
    },
    computed: {
        ThongTinDoanhNghiep: {
            get() {
                return this.$store.state.DoanhNghiep.ThongTinDoanhNghiep;
            },
            set(data) {
                this.$store.commit("DoanhNghiep/Set", {
                    key: "ThongTinDoanhNghiep",
                    data: data,
                });
            },
        },
    },
    methods: {
        Dong() {
            this.$emit("hiddenPopup", "PopupThongTinDoanhNghiep");
        },
        LuuThongTin() {
            let validate = this.$refs.formValidation.instance.validate();
            if (!validate.isValid) {
                return this.$Helper.Common.autoFocusError(validate);
            }
            this.ThucHienLuuThongTin();
        },
        async ThucHienLuuThongTin() {
            try {
                this.$startLoading;
                let rs;
                if (!this.ThongTinDoanhNghiep.IdDnvt) {
                    rs = await this.$store.dispatch("DoanhNghiep/TaoMoiDoanhNghiep");
                } else {
                    rs = await this.$store.dispatch("DoanhNghiep/CapNhatDoanhNghiep");
                }
                if (rs.status) {
                    this.$Helper.ThongBaoToast(
                        "success",
                        "Lưu thông tin doanh nghiệp thành công!"
                    );
                    this.Dong();
                    this.$emit("getData");
                } else {
                    this.$Helper.ThongBaoPopup({
                        message_title: "Lưu thông tin doanh nghiệp thất bại!",
                        message: rs.message,
                    });
                }
            } catch (error) {
                console.log("🚀 ~ error:", error);
                this.$Helper.ThongBaoPopup({
                    message_title: "Lưu thông tin doanh nghiệp thất bại!",
                    message: "Lỗi hệ thống client.",
                });
            } finally {
                this.$stopLoading;
            }
        },
    },
    created() {},
    mounted() {},
};
</script>
<style scoped></style>
<style lang="scss" scoped></style>
